import { render } from "react-dom";
import React from "react";
import ProductListings
  from "./product_listings/components/product_listings";

render(
  React.createElement(ProductListings),
  document.querySelector(".product_listings_container")
);
